<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal feed_image_modal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <div class="close-modal">
          <span (click)="dialogClose()" class="modal-close-icon"><i class="material-icons">close</i></span>
        </div>
        <!-- Modal content-->
        <div mat-dialog-content>
          <!-- Modal-Body -->
          <div class="modal-body">
            <div class="swiper-container" >
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                   <ng-container *ngIf="isImage(data.type)">
                    <img [src]="data.url" alt="Image">
                  </ng-container>
                  <ngx-doc-viewer *ngIf="isDocument(data.type)" [url]="data?.url" viewer="google"
                    style="width: 100%; height: 500px;"></ngx-doc-viewer>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
